define(function (require) {
	const ORGANIZATION = "organization";
	const PERSONAL = "personal";
	
	const view_manager = require('./view_manager.js');
	const profile_switch_model = require('civicsModels/portal/authentication/profile_switch_model');
	const profile_default_model = require('civicsModels/portal//profile_default_model');
	const user_data_utils = require('civicsUtils/user_data_utils.js');
  	const portal_user_model = require('civicsModels/account_model');

	return {
		switchProfile:function(profile, redirectUrl = "", skipReload = false){
			//this can get called with a model or an object. If it's a model, we need to convert it to an object
			let profileData = profile instanceof Backbone.Model ? profile.toJSON() : profile;
			let profileSwitchModel = new profile_switch_model();
			profileSwitchModel.id = profileData.id;
			profileSwitchModel.switchingToOrganization = profileData.type === ORGANIZATION;
			view_manager.loading(true);

			//once this call completes we're in the profile we wanted to switch to. The reload/redirect is just 
			//to make sure the UI is updated, and may not always be needed
			profileSwitchModel.fetch().done((response, status, xhrResponse) => {
				user_data_utils.processUserResponse(response.data, true);
				this.updatePage(redirectUrl, skipReload);
			}).fail((response, status, xhrResponse) => {
				view_manager.loading(false);
				view_manager.errorToWindow(response);
			});
		},
		updatePage:function(redirectUrl = "", skipReload = false){
			redirectUrl = this.cleanupUrl(redirectUrl);
			this.cleanupSession();
			if(redirectUrl){
				const hasFragment = redirectUrl.includes("#");
				const isSamePage = window.location.href.split("#")[0].trim().toLowerCase() === redirectUrl.split("#")[0].trim().toLowerCase();
		
				if (hasFragment && isSamePage) {
					window.location.reload();
				} else {
					// Direct navigation to a new page
					window.location.assign(redirectUrl);
				}
			} else if (!skipReload) {
				// Fallback for cases where no redirect URL is specified
				window.location.reload();
			}
		},
		switchToPersonalProfile:function(redirectUrl = "", skipReload = false){
			this.switchProfile(App.user.personalProfile, redirectUrl, skipReload);
		},
		changeDefaultProfile:function(profile){
			//this can get called with a model or an object. If it's a model, we need to convert it to an object
			let profileData = profile instanceof Backbone.Model ? profile.toJSON() : profile;
			view_manager.loading(true);
			let profileDefaultModel = new profile_default_model({
				//if this is an org, use the org's ID. otherwise, set to 1 to clear the default from all associated orgs
				organizationId: profileData.type === ORGANIZATION ? profileData.id : 1
			});
			let profileDefaultPromise = profileDefaultModel.save().done((response, status, xhrResponse) => {
				user_data_utils.processUserResponse(response.data, true);
			}).fail((response, status, xhrResponse) => {
				view_manager.errorToWindow(response);
			}).always(() => {
				view_manager.loading(false);
			});
			return profileDefaultPromise;
		},
		getPortalUser: function() {
			let portalUserModel = new portal_user_model();

			let portalUserFetchPromise = $.Deferred();

			portalUserModel.fetch().done((response, status, xhrResponse) => {
				user_data_utils.processUserResponse(response.data, true);
				portalUserFetchPromise.resolve();
			}).fail((response, status, xhrResponse) => {
				view_manager.errorToWindow(response);
				portalUserFetchPromise.resolve()
			});
			return portalUserFetchPromise;
		},
		cleanupUrl:function(redirectUrl){
			if(redirectUrl.trim()!==""){
				let decodedUrl = decodeURIComponent(redirectUrl);
				//Dev notes:
				//Absolute Paths - we expect the urls to be absolute path 
				// this will not work for Full URL with protocol: https://example.com/path
				let normalizeUrl = decodedUrl.	replace(/\/\/+/g, '/').replace(/^\/+/, '/');
				return  normalizeUrl;
			}
			//to give a smoother experience on the dashboard when switching profiles, we'll clear out the filter but retain the main portlet being displayed.
			//I'm not sure if this needs to be expanded in the future, but it should be as simple as adding more fragments to the array
			//Instrument lookup should be fine, as it's all public records.
			let newUrl = window.location.href;
			let fragments = ['#projects', '#assignments', '#tasks'];
			for(let fragment of fragments){
				newUrl = this.removeUrlFragmentIdentifier(fragment, newUrl);
			}
			return newUrl;
		},
		removeUrlFragmentIdentifier:function(fragment, url){
			let index = url.indexOf(fragment);
			if(index !== -1){
				return url.slice(0, index+fragment.length);
			}
			return url;
		},
		cleanupSession:function(){
			//this will clear out things like fees selected for payment, filters, and available instrument types (for the filter).
			view_manager.clearUserSpecificSessionStorage();
		},
		getProfileyByContactKey: function(contactKey) {
        	if (!contactKey) {
				return null;
			}
			
			return App.user.profiles.find(profile => profile.id == contactKey) || null;
		}
	}
});
